/**
 * Leaderboard - Shows top creatures by various metrics
 */

import { useState } from 'react';
import { useSimulationStore } from '../stores/simulationStore';
import { CollapsiblePanel } from './ui';
import type { LeaderboardEntry } from '../types/simulation';

interface LeaderboardProps {
  onSelectCreature: (creatureId: string) => void;
}

type LeaderboardTab = 'oldest' | 'mostOffspring' | 'highestEnergy';

const TAB_LABELS: Record<LeaderboardTab, string> = {
  oldest: 'Mas Vieja',
  mostOffspring: 'Mas Hijos',
  highestEnergy: 'Mas Energia',
};

const VALUE_LABELS: Record<LeaderboardTab, string> = {
  oldest: 'ticks',
  mostOffspring: 'hijos',
  highestEnergy: 'energia',
};

export function Leaderboard({ onSelectCreature }: LeaderboardProps) {
  const [activeTab, setActiveTab] = useState<LeaderboardTab>('oldest');
  const leaderboard = useSimulationStore((state) => state.leaderboard);
  const mySessionId = useSimulationStore((state) => state.sessionId);

  const entries: LeaderboardEntry[] = leaderboard[activeTab] || [];

  return (
    <CollapsiblePanel id="leaderboard" title="Clasificacion" defaultCollapsed>
      <div className="leaderboard-tabs">
        {(Object.keys(TAB_LABELS) as LeaderboardTab[]).map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {TAB_LABELS[tab]}
          </button>
        ))}
      </div>

      {entries.length === 0 ? (
        <p className="empty-text">Sin datos aun</p>
      ) : (
        <ol className="leaderboard-list">
          {entries.map((entry, index) => (
            <li
              key={entry.creatureId}
              className={`leaderboard-item ${entry.sessionId === mySessionId ? 'me' : ''}`}
              onClick={() => onSelectCreature(entry.creatureId)}
            >
              <span className="rank">#{index + 1}</span>
              <span className="player-name">{entry.displayName}</span>
              <span className="value">
                {entry.value} {VALUE_LABELS[activeTab]}
              </span>
            </li>
          ))}
        </ol>
      )}
    </CollapsiblePanel>
  );
}
